import React from "react";
import Link from "next/link";

export interface YearSidebarProps {
  yearEventCounts: { year: number; totalEvents: number }[];
  selectedYear: number;
  onYearSelect: (value: string) => void;
  maxShowYear: number;
  time: string;
  setSelectedYear: (year: number) => void;
}

const YearSidebar = React.memo(function YearSidebar({
    yearEventCounts,
    selectedYear,
    time,
    setSelectedYear,
    maxShowYear,
    onYearSelect,
  }: YearSidebarProps) {
  return (
    <div className="w-full md:w-1/5 h-full hidden lg:block lg:sticky lg:top-24 lg:self-start">
      <div className="w-full">
        <Link href={`/event/${time === "past" ? "archived" : ""}`} prefetch={false}>
          <h2 className=" text-xs font-Inter font-semibold">
            {time === "past" ? "PREVIOUS" : ""}
          </h2>
        </Link>
        <div className="relative"></div>
      </div>

      {/* {(maxShowYear)} */}
      {/* Dynamic year sections */}
      <div className="flex flex-col overflow-y-auto h-screen w-full pr-28 custom-scrollbar">
      {yearEventCounts.length > 0 ? (
        yearEventCounts.slice(0, maxShowYear).map((yearData, index) => (
          <div
            key={index}
            className={`border-b py-4 mb-2 w-full cursor-pointer ${
              selectedYear === yearData.year
                ? "border-orange"
                : "border-inkBlack/40"
            }`}
            onClick={() => setSelectedYear(yearData.year)}
          >
            <h3
              className={`font-medium text-xl ${
                selectedYear === yearData.year
                  ? "text-orange"
                  : "text-inkBlack/40"
              } mb-1`}
            >
              {yearData.year}
            </h3>
            <p className="text-inkBlack/40 text-sm">
              {yearData.totalEvents} events
            </p>
          </div>
        ))
      ) : (
        <p className="text-inkBlack/40">No events available</p>
      )}
      {time === "all" && (
        <div className="mt-8">
          <Link
            href="/events/archived"
            className="text-inactiveGray font-inter font-semibold text-xs hover:text-gray-600"
            prefetch={false}
          >
            VIEW MORE &gt;
          </Link>
        </div>
      )}
      </div>
    </div>
  );
});
export default YearSidebar;
